<div>
  <i nz-icon nzType="folder" nzTheme="twotone" class="header-icon"></i>&nbsp;<b
    class="header-label"
    >Generate Payroll</b
  >
</div>
@if (settings.loader) {
<ds-loading></ds-loading>
}
<div style="text-align: right">
  <button nz-button nzType="default" nzDanger (click)="gotopayrolls()">
    <span>Go Back</span>
  </button>
</div>
<div class="m-20">
  <div class="fltr_crd">
    <div style="color: black; font-weight: 500">
      Select Month & Year For Which Payroll Need To Be Generated
    </div>
    <form nz-form [formGroup]="searchForm">
      <div nz-row style="margin-top: 5px">
        <div nz-col nzSpan="4">
          <div class="filter-box">
            <div class="form-label">Year:</div>
            <nz-select
              nzShowSearch
              formControlName="yr_id"
              style="width: 90%; margin-bottom: 30px"
              (ngModelChange)="getMonths()"
            >
              @for (o of data.years; track o) {
              <nz-option [nzValue]="o.dt_yr" [nzLabel]="o.dt_yr"> </nz-option>
              }
            </nz-select>
          </div>
        </div>
        <div nz-col nzSpan="4">
          <div class="filter-box">
            <div class="form-label">Month:</div>
            <nz-select
              nzShowSearch
              formControlName="mnth_id"
              style="width: 90%; margin-bottom: 30px; margin-left: 10px"
            >
              @for (o of data.mnths; track o) {
              <nz-option [nzValue]="o.mnth_id" [nzLabel]="o.name"> </nz-option>
              }
            </nz-select>
          </div>
        </div>
        <div nz-col nzSpan="4">
          <div class="filter-box">
            <div class="form-label">Employee Type</div>
            <nz-select
              nzShowSearch
              formControlName="emple_type_id"
              style="width: 90%; margin-bottom: 30px"
            >
              <nz-option [nzValue]="zeroVal" nzLabel="All"></nz-option>
              @for (o of data.empleTypeLst; track o) {
              <nz-option
                [nzValue]="o.emple_type_id"
                [nzLabel]="o.emple_type_nm"
              >
              </nz-option>
              }
            </nz-select>
          </div>
        </div>
        <div nz-col nzSpan="4">
          <div class="filter-box">
            <div class="form-label">Employee Designation</div>
            <nz-select
              nzShowSearch
              formControlName="dsgns_id"
              style="width: 90%; margin-bottom: 30px; margin-left: 10px"
            >
              <nz-option [nzValue]="zeroVal" nzLabel="All"></nz-option>
              @for (o of data.dsgnsLst; track o) {
              <nz-option [nzValue]="o.dsgns_id" [nzLabel]="o.dsgns_nm">
              </nz-option>
              }
            </nz-select>
          </div>
        </div>
        <div nz-col nzSpan="3">
          <button
            nz-button
            nzType="primary"
            (click)="getEmployees()"
            style="margin-left: 30px; margin-top: 20px"
          >
            Get Employees
          </button>
        </div>
      </div>
    </form>
  </div>

  @if (settings.shwNtFndDiv == false) {
  <div>
    <label
      nz-checkbox
      [(ngModel)]="data.pyrle_rn_in"
      style="margin-left: 20px; margin-bottom: 22px"
      (ngModelChange)="shwNotAssigned()"
      >Exclude employees with payroll already generated</label
    >
  </div>
  } @if (settings.shwNtFndDiv == false) {
  <div>
    <!-- <nz-input-wrapper [nzPrefix]="prefixTemplateUser">
      <input nz-input placeholder="Search here..." [(ngModel)]="data.filterTerm" />
    </nz-input-wrapper>
    <ng-template #prefixTemplateUser><i nz-icon nzType="search"></i></ng-template> -->
    <div nz-row [nzGutter]="24" style="margin-top: 20px">
      <div nz-col [nzSpan]="8">
        Total Employees : <b>{{ data.allEmplesLst.length }}</b>
      </div>
      <div nz-col [nzSpan]="8">
        Selected Employees : <b>{{ data.slctdEmples.length }}</b>
      </div>
      <div nz-col [nzSpan]="8">
        Payroll Generated Employees :
        <b>{{ data.pyrleGnrtdEmpleLst.length }}</b>
      </div>
    </div>
    <div id="data-grid-demo">
      <app-data-grid
        [totalItems]="gridTotals0"
        id="gridContainer"
        [dataSource]="data.allEmplesLst"
        [legacyColumns]="data.columnDefs"
        [searchPanel]="true"
        [filterRow]="false"
        [filterPanel]="false"
        [groupPanel]="false"
        [columnChooser]="false"
        [allowExport]="false"
        [pageSize]="10"
        [allowedPageSizes]="[10, 25, 50, 100]"
        [showPageSizeSelector]="true"
        [rowAlternationEnabled]="true"
        [wordWrapEnabled]="true"
        selectionMode="multiple"
        (selectionChanged)="empSelectionChanged($event)"
        [isRowSelectable]="selectable_overrideOnValueChanged"
      >
        <!--  -->
        <app-grid-column
          dataField="sno"
          caption="S.No"
          width="50"
          alignment="center"
        ></app-grid-column>
        <app-grid-column
          dataField="dstrt_nm"
          caption="District"
          width="200"
          alignment="left"
        ></app-grid-column>
        <app-grid-column
          dataField="lctn_nm"
          caption="Rythu Bazar"
          width="200"
          alignment="left"
        ></app-grid-column>
        <app-grid-column
          dataField="emple_nm"
          caption="Employee Name"
          width="200"
          alignment="left"
        ></app-grid-column>
        <app-grid-column
          dataField="emple_nu"
          caption="Employee Number"
          width="150"
          alignment="left"
        ></app-grid-column>
        <app-grid-column
          dataField="dsgns_nm"
          caption="Designation"
          width="200"
          alignment="left"
        ></app-grid-column>
        <app-grid-column
          dataField="emple_type_nm"
          caption="Employee Type"
          width="200"
          alignment="left"
        ></app-grid-column>
        <app-grid-column
          dataField="wkng_dy_ct"
          caption="Working Days"
          width="100"
          alignment="center"
        ></app-grid-column>
        <app-grid-column
          dataField="pyrl_dy_ct"
          caption="Pay Days"
          width="100"
          alignment="center"
        ></app-grid-column>
        <app-grid-column
          dataField="tl_dy_ct"
          caption="Total Days"
          width="100"
          alignment="center"
        ></app-grid-column>
        <app-grid-column
          dataField="bsc_at"
          caption="Remuneration"
          width="150"
          alignment="center"
        ></app-grid-column>
        <app-grid-column caption="Employer Contribution">
          <app-grid-column
            dataField="emplr_epf_pct_at"
            caption="EPF"
            width="150"
            alignment="center"
          ></app-grid-column>
          <app-grid-column
            dataField="emplr_esi_pct_at"
            caption="ESI"
            width="150"
            alignment="center"
          ></app-grid-column>
        </app-grid-column>
        <app-grid-column caption="Employee Contribution">
          <app-grid-column
            dataField="emple_epf_pct_at"
            caption="EPF"
            width="150"
            alignment="center"
          ></app-grid-column>
          <app-grid-column
            dataField="emple_esi_pct_at"
            caption="ESI"
            width="150"
            alignment="center"
          ></app-grid-column>
        </app-grid-column>
        <app-grid-column
          dataField="it_pct_at"
          caption="IT Amount"
          width="100"
          alignment="center"
        ></app-grid-column>
        <app-grid-column
          dataField="pt_at"
          caption="PT"
          width="50"
          alignment="center"
        ></app-grid-column>
        <app-grid-column
          dataField="gst_pct_at"
          caption="GST"
          width="100"
          alignment="center"
        ></app-grid-column>
        <app-grid-column
          dataField="nt_at"
          caption="Total to be claimed"
          width="150"
          alignment="center"
        ></app-grid-column>
        <app-grid-column
          dataField="bnk_nm"
          caption="Bank Name"
          width="200"
          alignment="center"
        ></app-grid-column>
        <app-grid-column
          dataField="bnk_acnt_nu"
          caption="Bank Amount Number"
          width="200"
          alignment="center"
        ></app-grid-column>
        <app-grid-column
          dataField="ifsc_cd"
          caption="Bank IFSC Code"
          width="200"
          alignment="center"
        ></app-grid-column>
        <app-grid-column
          dataField="bnk_brnch_nm"
          caption="Bank Branch Name"
          width="200"
          alignment="center"
        ></app-grid-column>
        <app-grid-column
          dataField="pyrle_sts_nm"
          caption="Payroll Status"
          width="200"
          alignment="left"
        ></app-grid-column>
      </app-data-grid>
    </div>
    <div style="text-align: center; margin-top: 30px">
      <button
        nz-button
        nzType="primary"
        (click)="done()"
        [disabled]="data.slctdEmples.length == 0"
      >
        Generate Payroll
      </button>
    </div>
  </div>
  } @if (settings.shwNtFndDiv == true) {
  <div>
    <div class="shwNtFndDiv">No Employees Data Found</div>
  </div>
  }
</div>
